var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{attrs:{"id":"compartilhamento"}},[_c('button',{on:{"click":_vm.share}},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icons.faShareNodes}}),_c('strong',[_vm._v("Compartilhar")])],1),_c('Share')],1)}
var staticRenderFns = []

export { render, staticRenderFns }